// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VqwD","controls":"styles_controls__2ehTN","charLimit":"styles_charLimit__xSd38","input":"styles_input__tZShc","send":"styles_send__2L9QB"};